export default __webpack_public_path__ + "static/media/saint-pierre-sur-dives15.85cfb803.jpg";